(() => {
    const map = {"😂":"lisse-emoji-1f602.png","💜":"lisse-emoji-1f49c.png","✨":"lisse-emoji-2728.png","😍":"lisse-emoji-1f60d.png","😅":"lisse-emoji-1f605.png","🥰":"lisse-emoji-1f970.png","↗":"lisse-emoji-2197.png","👍":"lisse-emoji-1f44d.png","❤️":"lisse-emoji-2764.png","🎁":"lisse-emoji-1f381.png","🚚":"lisse-emoji-1f69a.png","🛡️":"lisse-emoji-1f6e1.png","🌬️":"lisse-emoji-1f32c.png","🪮":"lisse-emoji-1faae.png","🪞":"lisse-emoji-1fa9e.png","🔋":"lisse-emoji-1f50b.png","🌡️":"lisse-emoji-1f321.png","🔌":"lisse-emoji-1f50c.png","👜":"lisse-emoji-1f45c.png","⏱️":"lisse-emoji-23f1.png","⚡":"lisse-emoji-26a1.png","📅":"lisse-emoji-1f4c5.png","☀️":"lisse-emoji-2600.png","🌙":"lisse-emoji-1f319.png","🏋️":"lisse-emoji-1f3cb.png"};
    const base = new URL('.', document.currentScript.src);
    const segmenter = new Intl.Segmenter('es', {granularity:'grapheme'});
    function render(root) {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while(walker.nextNode()) nodes.push(walker.currentNode);
      for(const node of nodes) {
        if(node.parentElement.closest('script,style,textarea,svg,.lisse-emoji')) continue;
        if(!/\p{Extended_Pictographic}/u.test(node.data)) continue;
        const parts = [...segmenter.segment(node.data)];
        if(!parts.some(p=>map[p.segment])) continue;
        const fragment = document.createDocumentFragment();
        let text = '';
        for(const {segment} of parts) {
          if(!map[segment]) {text += segment;continue;}
          if(text){fragment.append(document.createTextNode(text));text='';}
          const image = document.createElement('img');
          image.className = 'lisse-emoji';image.alt = segment;
          image.width = 24;image.height = 24;image.decoding = 'async';
          image.src = new URL(map[segment], base).href;
          fragment.append(image);
        }
        if(text) fragment.append(document.createTextNode(text));
        node.replaceWith(fragment);
      }
    }
    render(document.body);
    document.addEventListener('shopify:section:load', e=>render(e.target));
  })();